module.exports = __webpack_public_path__ + "assets/img/infoItem02.86c4da85.png";